export default "__VITE_ASSET__BUd4YcRV__"